export interface BaseDataGridRequest {
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: boolean;
}
